import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Tailwind-merge's default config doesn't know about our custom font-size
// theme tokens (`body-sm`, `h1`, etc.), so it treats `text-body-sm` as a
// generic `text-*` class and conflicts it with color classes like
// `text-gray` — dropping the size silently. Teach it the token names so
// font-size and color can coexist on the same element. Any newly added
// design-system font-size token must also be added to this extension list,
// or cn silently eats it next to any text color.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        'display',
        'h1',
        'h2',
        'body-lg',
        'body-md',
        'body-sm',
        'body-micro',
      ],
    },
  },
});

// The app-wide className composer: clsx flattening (strings, arrays,
// conditional objects; falsy entries dropped) piped through tailwind-merge
// conflict resolution — on a genuine utility conflict the last class wins.
// Use it for every conditional/merged className; plain template concat
// cannot override earlier utilities. With the extension above, a font-size
// token and a text color coexist; two font-size tokens (or two colors)
// still conflict-resolve to the last one.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
